import Common from './common.js'

const Mixins = [ Common ]

export default Mixins